import { inject, Injectable } from '@angular/core';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { ContentModal } from '../modals/content-modal/content-modal';
import {
  ConfirmationModal,
  ConfirmationModalConfig,
} from '../modals/confirmation-modal/confirmation-modal';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private dialog = inject(Dialog);
  private dialogRef: DialogRef<any, any> | undefined;

  openModal<T>(
    component: ComponentType<unknown>,
    width: string = '600px',
    height: string = 'auto',
    title: string | undefined,
    inputs?: Partial<T>,
    outputs?: Partial<Record<keyof T, (value: any) => void>>,
  ): DialogRef<T, unknown> {
    this.dialogRef = this.dialog.open<T>(ContentModal, {
      width: width,
      height: height,
      data: { component, title: title ?? undefined, inputs, outputs },
    });
    return this.dialogRef;
  }

  openConfirmation<T extends string>(
    config: ConfirmationModalConfig<T>,
    width: string = '600px',
  ): DialogRef<T, unknown> {
    return this.openModal<T>(ConfirmationModal, width, 'auto', undefined, config as never);
  }

  closeModal(): void {
    if (this.dialogRef) this.dialogRef.close();
  }
}
